import { Box, styled, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.orderName,
  padding: "26px 30px 19px 30px",
}));
export const StyledBoxPadTop = styled(Box)(() => ({
  paddingTop: "14px",
}));
export const StyledBoxPad = styled(Box)(() => ({
  padding: "14px 30px",
  cursor: "pointer",
}));

export const StyledBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  height: "100%",
}));

export const StyledTypographyTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.blackColor,
}));
export const StyledTypographyMem = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.chipColor.fontSize,
  color: theme.palette.custom.orderCards,
}));
export const StyledGridLocker = styled(Grid)(() => ({
  padding: "14px 20px",
}));
export const StyledBoxInnerHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 15px",
  borderStartEndRadius: theme.borderRadius.radius.regular, //Rishabh
  backgroundColor: theme.palette.custom.chatBoxColor,
}));

export const StyledEmptyState = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "28px",
  minHeight: "calc(100vh - 220px)",
  width: "100%",
  padding: "72px 32px",
  borderRadius: theme.borderRadius.radius.regular,
  background:
    "linear-gradient(180deg, rgba(255, 248, 237, 0.9) 0%, rgba(255, 255, 255, 1) 100%)",
  border: `1px dashed ${theme.palette.custom.lightBorder || "#E7D7BF"}`,
  boxSizing: "border-box",
}));

export const StyledEmptyStateVisual = styled(Box)(({ theme }) => ({
  width: "180px",
  height: "180px",
  borderRadius: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(180deg, #F5FAFF 0%, #E7F2FF 100%)",
  border: `1px solid ${theme.palette.custom.lightBorder || "#D4E3F6"}`,
  boxShadow: "0 24px 44px rgba(11, 101, 181, 0.12)",
}));

export const StyledEmptyStateImage = styled("img")(() => ({
  width: "110px",
  height: "110px",
  objectFit: "contain",
}));

export const StyledEmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontSize: "32px",
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.blackColor,
  lineHeight: 1.2,
}));

export const StyledEmptyStateText = styled(Typography)(({ theme }) => ({
  maxWidth: "620px",
  fontSize: "18px",
  color: theme.palette.custom.orderCards,
  lineHeight: 1.6,
}));

export const StyledEmptyPanel = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  gap: "12px",
  minHeight: "290px",
  padding: "32px 24px",
}));

export const StyledEmptyListCard = styled(Box)(({ theme }) => ({
  margin: "16px 24px 24px",
  minHeight: "120px",
  borderRadius: theme.borderRadius.radius.custom,
  border: theme.borders.highlighted,
  background: "linear-gradient(180deg, #F8FBFF 0%, #FFFFFF 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
}));
